import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { CurrentUser } from 'src/app/core/user.service';

@Injectable({ providedIn: 'root' })
export class FlightLogUserGuard implements CanActivate {
  constructor(private _user: CurrentUser, private _router: Router) {}

  public async canActivate() {
    return this.isFlightLogUser();
  }

  public async isFlightLogUser() {
    const user = await this._user.valueChanges.pipe(take(1)).toPromise();
    if (user?.isFlightLogUser) {
      return true;
    }
    this._router.navigate(['/unauthorized']);
    return false;
  }
}
